export default {
  /*按钮*/
  bt:{
    search: "Search",
    query:"Query",
    operation:"operation",
    add:"Add",
    edit: "Modify",
    delete: "Delete",
    down: "Download",
    export:"Export",
    upload: "Upload",
    enable:"enable",
    disable:"disable",
    copy:"Copy",
  },
  /*Public field or tool function field*/
  common:{
    startTime: "Start Time",
    endTime: "End Time",
    creator: "Creator",
    updater: "Updater",
    createTime: "Create Time",
    updateTime: "Update Time",
    phone:"Mobile Number",
    name:"Name",
    email:"Email",
    idNumber: "ID Number",
    status:"Status",
    remark: "Remarks",
  },
  /*User tracking page*/
  kscore:{
    month: "Number of active periods",
    profit: "Profit",
    detail:"Details",
    symbol:'tradeConfig name',
    direction:'Buying and selling direction',
    openPrice:'Opening price',
    closePrice:'Close price',
    createTime:'Close time',
    customer:'customer'
  },
  registerLog:{
    dataType: "Data Type",
    driverType: "Device Type",
    utmSource: "Source",
    utmMedium: "Medium",
    utmCampaign:"Campaign",
    utmContent:"Ad Group",
    utmTerm: "Keyword",
    ipAddress: "IP Location",
    href:"Source URL",
    referrer: "Landing Page",
    directPhone: "referrer's mobile phone number",
    phonePre: "Phone Area Code",
    title:"Gender",
    businessType: "Business Group",
    ruleId: "SMS rule id",
    register:"Original Customer List",
    agentCode:"agentCode",
  },
  accountReward:{
    activeId: "Activity ID",
    activeStatus: "Active Status",
    activeName: "Activity Name",
    activeType: "Activity Type",
    proposalNo: "Proposal Number",
    beginDate: "Activity start time",
    endDate: "Activity end time",
    expDay: "Validity Period",
    proposalUser: "Proposer",
    proposalDate: "Proposal Time",
    approvalUser: "Approval Person",
    approvalDate: "Approval time",
    proposalType: "Proposal Type",
    proposalStatus: "Proposal Status",
    applyProposal: "Execute Proposal",
    cancelProposal: "Cancel Proposal",
    applySuccess: "Successful execution",
    applyFail: "Execution failed",
    choiceOne: "Please choose a proposal",
    notSatisfiable: "The proposal does not meet the requirements",
    downloadProActivity: "Recommended bonus activity proposal",
    excuteCustomerNumber:'Member Account',
    demo:'Account Type',
    levelType:'Account level',
    mobilePhone:'Phone',
    chineseName:'Name',
    directPhone:'Direct referrer',
    directindirect:'Direct/indirect referrer',
    indirectPhone:'Indirect Referrer',
    symbolType:'Product Type',
    execVolume:'Number of transactions',
    complianceExecVolume:'Customer trading lots/compliant lots',
    complianceStatus:'Compliance status',
    ctime:'Time to reach standard',
    userCreateDate:'Account opening time',
    activeTime:'Activation time',
    downloadEffectiveCustomer:'Effective Customer Record',
    downloadActivity:'Trading rebate activity',
    downloadActivity0:'Recommended bonus activity',
    acitveDate:"Activity time",
    hierarchy:"Level settings",
    product:"Recommended bonus settings",
    approve:"Approve",
    to:"to",
    Reward:"Reward",
    time:"Times",
    condition:"Condition setting",
    me:"client",
    direct:"Direct recommendation",
    indirect:"Indirect recommendation",
    quantity:"Trading lot requirements",
    tradeConfig:"tradeConfig"
  },
  rewardTradeDetails:{
    currentCustomerNumber:'Settlement account number',
    currentMobilePhone:'Settlement account phone number',
    currentChineseName:'settlement account name',
    excuteCustomerNumber:'Customer trading account number',
    mobilePhone:'Customer Mobile Number',
    demo:'Account Type',
    levelType:'Account level',
    symbolType:'Product Type',
    symbol:'Product',
    orderid:'position number',
    execVolume:'Number of transactions',
    relationType:'reward type',
    directPhone:'Direct referrer',
    indirectPhone:'Indirect Referrer',
    currentRebete:'Amount',
    ctime:'Settlement time',
    downloadTradeDetails:'Reward Details Record',
  },
  rewardDealList:{
    createDate:'Settlement time',
    currentCustomerNumber:'Settlement account number',
    currentMobilePhone:'Settlement mobile phone number',
    currentChineseName:'settlement customer name',
    customerStatus:'Account Status',
    currentRebete:'Reward amount',
    correctionRebete:'Adjustment amount',
    finalRebete:'Final rebate',
    proposalStatus:'Status',
    updateUser:'modified person',
    updateDate:'modification time',
    approvalUser:'Approval person',
    approvedDate:'Approval time',
    remark:'Remarks (Rejection Reason)',
    confirmSubmit:'Confirm Submit',
    confirmSuccess: "Submit successfully",
    confirmFail: "Submit failed",
    cancel:'Cancel',
    confirm:'OK',
    cancelProposal:'Cancel Proposal',
    refuse:'Reject the proposal',
    apply:'Approval',
    reason:'reason',
    limit:'Limit adjustment table',
    refuseProposal:'Refuse',
    downloadLimit:'download limit adjustment table',
    refId:"Issue award number",
    approval:"Confirm approval",
  },
  relationList:{
    customerRelation:'User recommendation relationship',
    customerRelationPro:'User recommendation relationship proposal',
    customerNum:'transaction account number',
    mobilePhone:'Mobile phone number',
    userName:'Name',
    userLevel:'Account Level',
    createDate:'Account opening date',
    activeTime:'Activation time',
    newdirectPhone:'Direct recommender',
    remark:'Remarks',
    customerNumber:'member account',
    phone:'Phone',
    direct:'Direct/Indirect Referrer',
    matchType:'Recommendation relationship',
    activeStatus:'Activation Status',
    demoCustomerNum:'Analog Account',
    directNumber:'Direct recommender account',
    directPhone:'Directly recommend the person phone',
    indirectNumber:'indirect referrer account',
    indirectPhone:'Indirect referral phone',
    reStatus:'matching result',
    proposalUser:'Proposer',
    proposalDate:'Proposal time',
    approvalUser:'Approval person',
    approvalDate:'Approval time',
    applyProposal: "Execute Proposal",
    cancelProposal:'Cancel Proposal',
    beginDate:'Account opening start time',
    endDate:'Account opening end time',
    proposalStatus:'Proposal Status',
    proposalNo:'Proposal number',
    relationOpenUrl:"Customer referral link query",
    relationCount:"Recommended number",
    relationStandardCount:"Recommended number of people",
    nationality:'nationality',
  },
  faceConfig:{
    deleteSuccess:'Delete successfully!',
    updateSuccess:'Modified successfully!',
    code:'channel code',
    name:'channel name',
    type:'Verification Type',
    thirdParty:'Third Party Interface',
    cost:'cost',
    status:'Status',
    remark:'Remarks',
    verifyCode:'Manufacturer Channel',
    verifyType:'Verification Type',
    verifyTypeCN:'Verify Type Chinese',
    describe:'Verify description',
    device:'Platform Type',
    channel:'Channel name',
    version:'Version number',
    switchCode:'Channel switch',
    faceStatus:'Face Control',
    createDate:'Created time',
    createUser:'Creator',
    updateUser:'Modify person',
    updateDate:'Modification time',
    submitSuccess:'Operation successful',
    faceRecord:'Verification Record',
    chineseName:'Name',
    card:'ID',
    phone:'Mobile phone number',
    recordDate:'Record time',
    channelName:'channel name',
    result:'Comparison result',
    resultParam:'Query output',
    count:'Number of uses',
    successCount:'Number of successes',
    artificialCount:'Number of successful manual calls',
    systemCount:'Number of successful system calls',
  },
  creditLevel:{
    updateList:'Credit rating modification list',
    journal:'modification log',
    batchImport:'Batch import',
    uploadTip:'Drag the file here, or',
    uploadTip1:'click to upload',
    uploadTip2:'Only upload xlsx files, and no more than 10M',
    uploadSuc:'File upload successfully',
    uploadFail:'File upload failed',
    downTemplate:'Download template',
    uploadFile:'Upload now',
    batchUpdate:'Batch modification',
    customerNo:'Member account',
    pkey:'P tag',
    creditLevelOld:'Credit level before modification',
    creditLevelOriginal:'Current user credit level',
    creditLevel:'Credit Level',
    remark:'Remarks',
    createDate:'Created time',
    createUser:'Creator',
    updateUser:'Modify person',
    updateDate:'Modification time',
  },
  rebateComponents:{
    subtotal:'Subtotal',
    total:'Total',
    tradeLogList:'Rebate details record details',
    cancel:'Cancel',
    confirm:'Confirm',
    symbolType:'Product Type',
    displayName:'Product',
    orderId:'position number',
    execVolume:'Trading lots',
    execTime:'Trading Time',
    rebateAmount:'rebate amount',
    activeName:'active name',
    activity:'activity time',
    activeId:'Activity ID',
    effective:'Effective customer condition setting',
    tips:'New customer account opening and activation time must be within the activity period',
    beginDate: "Start Time",
    endDate: "End Time",
    expDate: "Start Date of Validity Period",
    expDay: "Validity Period",
    productType: "Product Type",
    me: "Customer",
    direct: "Direct Recommendation",
    indirect: "Indirect recommendation",
    quantity: "Requirements for the number of transactions",
    highAmount:'Highest reward amount',
    highAmount2:'New customers highest contribution rebate',
    highPoint:'Customers recommended accumulatively get the highest rebate',
    add:'Add',
    update:'Modify',
    dollar:'dollar',
    day:'day',
    activeTime:'Activation Date',
    reward:'Recommended bonus setting',
    rebate:'Trading rebate settings',
    addCondition:'Add Condition',
    min:'mini',
    std:'standard',
    vip:'Golden Diamond',
    to:'to',
    all:'All',

  },
  risk:{
    name:"Gateway Name",
    baseSetting: "Basic User Configuration",
    specialSetting: "Specific User Configuration",
    ipSetting: "ip rule configuration",
    addBaseSetting: "Add Rule User Group",
    addspecialSetting: "Add a specific user group",
    settingTpye: "Configuration Type",
    userType: "User Group",
    pkey: "P tag",
    nkey: "N tag",
    creditLevel: "Credit Level",
    utmSource: "Source",
    utmMedium: "Medium",
    utmCampaign:"Campaign",
    limitSetting: "Limit Rules",
  },
  registervalidate:{
    customerNo: "Account",
    registerType: "Account Opening Type",
    target:"tag",
    creditTunnel2: "Credit Channel 2",
    creditTunnel3: "Credit Channel 3",
    validateStatus2: "Two-element validation status",
    validateStatus3: "Three-element validation status",
    registerStatus: "Account Opening Status",
    channel: "channel source",
    kycResult: "kyc verification result",
    personMarkTunnel: "Credit Investigation Litigation Channel",
    personMarkResult: "Credit Investigation Litigation Verification Result",
    creditLoanTunnel: "Credit Overdue Channel",
    creditLoanResult: "Credit overdue verification result",
  },
  tracker:{
    customerNo: "User Account",
    openStartTime: "Account opening start time",
    openEndTime: "Account opening end time",
    activeStartTime: "Activation start time",
    activeEndTime: "Activation End Time",
    userType: "Account Type",
    isActive: "Activation Status",
    isShow: "Column segment display/hide",
    day:"day",
    week:"week",
    month:"month",
    reset:"reset",
    businessType: "Business Group",
    relatedAccount: "Associated Account",
    levelType: "Account Level",
    userAge: "Age",
    gender:"Gender",
    birthday:"Date of Birth",
    ctime: "Account Opening Date",
    pkey: "P tag",
    nkey: "N tag",
    creditLevel: "Credit Level",
    href:"source url",
    utmSource: "Source",
    utmMedium: "Medium",
    utmCampaign:"Campaign",
    utmContent:"Ad Group",
    utmTerm: "Keyword",
    referrer:"Landing Page",
    channel:"Source Opening",
    activeTime: "Activation Time",
    ipAddress: "IP Location",
    userAgent: "Browser",
    checkStatus: "IVI Verification Status",
    arbitrageurTags: "IVI Verification Tag",
    directPhone: "referrer's mobile phone number",
    tracker: "User Tracking",
    team:"team",
    countryCode:"country Code",
    mediaSource:"mediaSource",
    campaign:"campaign",
    afChannel:"afChannel",
    afPrt:"af_partner",
    installTime:"installTime"
  },
  activeTemplate:{
    type:"Activity Type",
    url: "Release domain name",
    detail: "Module Template",
    field:"Ad Attributes",
    fieldTitle: "Attribute Name",
    fieldField: "Attribute Code",
    fieldType: "Attribute Type",
    text:"Text",
    img:"Picture",
    title:"Template Title",
    activeTime: "active time",
    author:"Publisher",
    editor:"Rich Text Format",
    textarea:"textarea",
    copy:"Copy",
    modelField:"modelField"
  },
  advertising:{
    key: "key",
    value: "value",
    type: "type",
    createTime:"createTime",
    updateTime:"updateTime",
    name:"Name of advertising",
    platform:"Application platform",
    term:"The period of validity",
    accountType:"Account type",
    isActive:"active",
    userLevel:"Account level",
    aboutType:"Degree of conversion",
    position:"Advertising position",
    positionType:"AD types(1:'picture',2:'words')",
    channel:"channel",
    language:'language',
    adverInfo:"Jump Address",
    startTime:"The start time",
    endTime:"Effect of time",
    status:"state",
    carapace:"Vest bag",
    time:"To take effect",
    param:"Apply to the user",
    url:"To upload pictures",
    title:"The title",
    preinstall:"Terms and Conditions",
    address:"address",
    content:"content",
    sort:"sort",
    simulation:"simulation",
    real:"real",
    demoCaseReal:"demoCaseReal",
    nationality:"nationality",
  },
  analy:{
    dayActive:"Number of account activate in real-time of the day",
    dayReal:"Real account opened on the day",
    dayDemo:"Demo account opened on the day",
    dayRealDemo:"Real account+demo account opened on the day",
    in:"that",
    dayRealActive:"The number of accounts opened and activated on the day",
    weekActiveCount:"The number of activated on last 7 days",
    weekRealCount:"The Number of real accounts opened in last 7 days",
    weekDemoCount:"The Number of demo accounts opened in last 7 days",
    weekRealDemoCount:"The Number of real+demo accounts opened in last 7 days",
    realCount:"Real accounts",
    demoCount:"Demo accounts",
    realDemoCount:"Real+Demo accounts",
    averCount:"Working Day Average line",
    week0: "Sunday",
    week1: "Monday",
    week2: "Tuesday",
    week3: "Wednesday",
    week4: "Thursday",
    week5: "Friday",
    week6: "Saturday",
    dayActiveRate:"The ratio of channels for activated real-time on the day",
    dayRealRate:"The ratio of channels for real account real-time on the day",
    dayDemoRate:"The ratio of channels for demo account real-time on the day",
    dayRealDemoRate:"The ratio of channels for real+demo account real-time on the day",
    dayRealCount:"Real account opened real time on the day",
    dayDemoCount:"Demo account opened real time on the day",
    dayRealDemoCount:"Real+Demo account opened real time on the day",
    today:"Today",
    yesterday:"Yesterday",
    activeCount:"Activation Number",
  },
  smsType:{
    device:"Page side",
    type:"Verification code method",
    updateTime:"Change the time",
    modify:"Switching method"
  },
  currencySymbol:{
    symbol:"symbol",
    lang:"lang",
    currency:"currency",
    time:"time",
    total:"total",
    uccnUrl:"Official website",
    whiteUrl:"white paper",
    detail:"detail",
    updateTime:"update Time"
  },
  country:{
    code: "code",
    nameCn: "nameCn",
    nameEn: "nameEn",
    mobilePhonePrefix: "mobilePhonePrefix",
    sort: "sort(big->small)",
  },
  team:{
    name: "name",
    country: "country（multiple, separated）",
    utmSource: "Source（multiple, separated）",
    utmMedium: "Medium（multiple, separated）",
  },
  optional:{
    iCodeId: "code",
    symbol: "symbol",
    platform: "platform",
    businessType: "businessType",
    accountNo: "accountNo",
    account: "account",
    createTime: "create Time",
    channel: "channel",
  },
  relationAnaly:{
    time:"Statistics month",
    customerNumber:"customer Number",
    inviteTotal:"invite Total",
    inviteMonthTotal:"invite Month Total",
    tradeTotal:"trade Total",
    tradeMonthTotal:"trade Month Total",
    year:"year",
    month:"month",
    relationAnaly:"relation Analy",
    monthTotal:"month Total",
    allTotal:"all Total",
    people:"people",
    efficientRelation:"efficient Relation",
    trade:"trade",
    volume:"volume",
    ctime:"create time",
    activeTime:"actived time",
    customerDetail:"customer Detail",
    tradeDetail:"trade Detail",
  },
  operations:{
    totalMem: "totalMem",
    tradeTime: "tradeTime",
    sud: "sud",
    usd: "usd",
  },
  coin:{
    depthQtyDigitsLength: "depthQtyDigitsLength",
    depthPriceDigitsLength: "depthPriceDigitsLength",
    depthQtyMin: "depthQtyMin",
    code: "code",
    symbol: "symbol",
    status: "status",
    ip: "ip",
    depthPercentPrice: "depthPercentPrice",
    depthPercentQty: "depthPercentQty",
    tradeQtyMin:"tradeQtyMin",
    depthQtyRandomTimes:"深度行情成交量倍数(间隔符号|,:—_)",
    tradeQtyRandomTimes:"交易记录量倍数(间隔符号|,:—_)"
  },
  socialMedia: {
    common: {
      id: "ID",
      createdAt: "Created Time",
      updatedAt: "Updated Time",
      createdBy: "Create User",
      updatedBy: "Update User",
      option: "Please select",
      undefined: "Undefined",
      empty: "-"
    },
    message: {
      invalid: "Invalid operation",
      success: "Request succeeded",
      fail: "Request failed",
      unknown: "Unknow error",
      duplicate: "Duplicate data",
      channelNotEmpty: "Channel cannot be empty"
    },
    platform: {
      form: {
        name: {
          label: "Platform Name",
          placeholder: "Platform Name",
        }
      },
      table: {
        platform: "Platform Icon",
        image: "Platform Icon"
      },
      modal: {
        platform: {
          label: "Platform Name",
          placeholder: "Please enter platform name",
        },
        image: {
          label: "Platform Icon",
          placeholder: "Please enter platform icon",
        }
      }
    },
    channel: {
      form: {
        name: {
          label: "Channel Name",
          placeholder: "Channel Name"
        },
        code: {
          label: "Channel Code",
          placeholder: "Channel Code"
        },
        system: {
          label: "System Type",
          placeholder: "Any"
        }
      },
      table: {
        channel: "Channel Name",
        code: "Channel Code",
        system: "System Type",
      },
      modal: {
        channel: {
          label: "Channel Name",
          placeholder: "Please enter channel name",
        },
        code: {
          label: "Channel Code",
          placeholder: "Please enter channel code",
        },
        system: {
          label: "System Type",
          placeholder: "Please select system type",
        },
      }
    },
    account: {
      form: {
        channel: {
          label: "Channel Name",
          placeholder: "Channel Name"
        },
        platform: {
          label: "Platform Name",
          placeholder: "Platform Name"
        },
        system: {
          label: "System Type",
          placeholder: "Any"
        },
        status: {
          label: "Active Status",
          placeholder: "Any"
        },
        fromTime: {
          label: "From",
          placeholder: "Created Time"
        },
        toTime: {
          label: "To",
          placeholder: "Created Time"
        }
      },
      table: {
        sort: "Sort",
        platform: "Platform",
        url: "URL",
        web: "WEB Channel",
        m: "M Channel",
        app: "APP Channel",
        status: "Status"
      },
      modal: {
        platform: {
          label: "Platform",
          placeholder: "Please select platform",
        },
        url: {
          label: "URL",
          placeholder: "Please enter the URL of social media account"
        },
        web: {
          label: "WEB Channel",
          placeholder: "web"
        },
        m: {
          label: "M Channel",
          placeholder: "m"
        },
        app: {
          label: "APP Channel",
          placeholder: "app"
        },
        sort: {
          label: "Sort",
          placeholder: "999"
        },
        status: {
          label: "Status",
          placeholder: "Status"
        }
      }
    }
  }
};
